import { render, staticRenderFns } from "./ComplieLeftContentMindMenu.vue?vue&type=template&id=52610163&scoped=true"
import script from "./ComplieLeftContentMindMenu.vue?vue&type=script&lang=js"
export * from "./ComplieLeftContentMindMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieLeftContentMindMenu.vue?vue&type=style&index=0&id=52610163&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52610163",
  null
  
)

export default component.exports